import React, {
    memo

} from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import '../../../../../styles/SmartRent.css';
import FormInput from '../../../../common/form/Input';
import {
    //addSmartRentRemoteKey,
    // deleteSmartRentIntegration, 
    //deleteSmartRentKey,
    SmartRentConfiguration,
} from '../../../../../api/PropertyIntegration';
//import { ApiResult } from '../../../../../api/Shared';
// import Row from 'reactstrap/lib/Row';
//import Button from '../../../../common/form/Button';
//import SmartRentConfigUnit from './SmartRentConfigUnit';
// import { prospectComparer } from '../../ProspectsSubPage';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: SmartRentConfiguration;
    id: number;
    reload: () => Promise<void>;
    update: (newConfig?: SmartRentConfiguration) => void;
    setIsLoading: (isLoading: boolean) => void;
}

const SmartRentConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();

    // const [units, setUnits] = useState<any>(props.config!.units);
    //const [isCardOpen, setIsCardOpen] = useState(!!props.config);

    // function callApiAction<T>(
    //     apiFunction: () => Promise<ApiResult<T>>,
    //     successFunction: (data?: T) => void,
    //     errorDefault: string
    // ) {
    //     return async () => {
    //         // setError(undefined);
    //         // setIsLoading(true);
    //         let result = await apiFunction();
    //         // setIsLoading(false);
    //         if (result.success) {
    //             successFunction(result.data);
    //         } else {
    //             // setError(result.error || errorDefault);
    //         }
    //     };
    // }

    // const handleUnitsUpdate = async (newUnit: any) => {
    //     if (newUnit.name !== '' && newUnit.remoteUnitId !== '') {
    //         await callApiAction(
    //             () => addSmartRentRemoteKey(props.id, props.config!.smartRentPropertyId, newUnit),
    //             () => props.reload(),
    //             'Failed to add key'
    //         )();
    //     } else {
    //         alert('');
    //     }

    // };
    // const handleDelete = (RemoteUnitId: string) => {
    //     callApiAction(
    //         () => deleteSmartRentKey(props.id, props.config!.smartRentPropertyId, RemoteUnitId),
    //         () => props.reload(),
    //         'Failed to delete key'
    //     )();
    // };
    // const handleDeactivate = (propertyId:number) => {
    //     callApiAction(
    //         ()=> deleteSmartRentIntegration(propertyId),
    //         ()=> props.reload(),
    //         'Failed to deactivate'
    //     )();
    // };
    return (
        <CollapsibleCard
            cardTitle="Smartrent Access"
            cardOpen={!!props.config}
            onCardOpenChange={open => {
                if (isUser)  return;

                props.update(
                    open
                        ? { ...props.config! }
                        : undefined
                );

                //     if(open && !props.config) {
                //         setIsCardOpen(true);
                //         props.update(          
                //             {
                //                 smartRentPropertyId: '',
                //                 units:[]
                //             }                         
                //         );
                //     }
                //     else if(open && props.config) {
                //         setIsCardOpen(true);

                //     }
                //     else if(!open){
                //         setIsCardOpen(false);
                //         props.update(undefined);
                //     }
                //     else {
                //         setIsCardOpen(true);
                //     }

                // }}

                // if(open && !props.config) { 
                //     props.update({...props.config!, smartRentPropertyId: ''});
                //     setIsCardOpen(true);
                // } else if(open && props.config) {
                //     setIsCardOpen(true);
                // } else if(!open){
                //     setIsCardOpen(false);
                //     // props.update({...props.config!, smartRentPropertyId: ''});
                // }
                // }} 
            }}
        >
            <div>
                <div className="smart-rent-form-wrapper">
                    {/* {props.config && props.config.smartRentPropertyId &&
                    <div className="deavticate-btn-wrapper">
                        <Button 
                            text="Deactivate"                             
                            onClick={()=> handleDeactivate(props.id)}
                            suppressBottomMargin={true}
                        />
                    </div>
                    }                     */}
                    <FormInput
                        labelProps={{
                            labelText: 'Property Code',
                            invalidText: 'Please enter a Stratis Property ID'
                        }}
                        inputProps={{
                            id: 'smart-rent-property-id',
                            name: 'smartRentPropertyId',
                            value: props.config ? props.config.smartRentPropertyId : '',
                            type: 'string',
                            // required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, smartRentPropertyId: value.toString() })

                        }
                    />
                    {/* {props.config && props.config!.smartRentPropertyId &&
                        // <SmartRentConfigUnit
                        //     units={props.config ? props.config.units : []}
                        //     onChange={newUnit => handleUnitsUpdate(newUnit)}
                        // />
                    } */}

                </div>
                {/* {props.config && props.config.units ?
                    props.config.units.map((unit:
                        {
                            name: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
                            remoteUnitId: string;
                        }, index: number) => {
                        return (
                            <div key={'name' + index} className="smart-rent-unit-form-wrapper">
                                <div className="smart-rent-unit-form-input">
                                    {unit.name}
                                </div>
                               
                                <div className="smart-rent-unit-form-input">
                                    {unit.remoteUnitId}
                                </div>
                                <div className="smart-rent-form-last-col">
                                    <Button text="Delete" onClick={() => handleDelete(unit.remoteUnitId)} />
                                </div>

                            </div>
                        );
                    })
                    : ''
                } */}

                {/* <hr/>
                <div className="smart-rent-delete-btn-wrapper">
                    <Button text="Delete Selected" onClick={handleDeleteSelected} />
                </div>                  */}
            </div>
        </CollapsibleCard>
    );
};

export default memo(SmartRentConfigurationSection);


// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/SmartRentConfiguration.tsx